import {store} from "../../../navigation/ReduxProvider";
import AuthenticatedEntity from "../../user/AuthenticatedEntity";
import {Option, option} from "ts-option";
import {LeadBDPChangeNotificationDataApiDto} from "../../../api/model/rest";
import {getLeadByIdOrRefNo} from "../../../store/view/lead";

/**
 * Lead BDP change notification class data.
 */
export default class LeadBDPChangeNotificationData {
	/**
	 *
	 * @param {string} leadId
	 * @param {string} entity Entity from who assignee change originates.
	 * @param {Option<string>} previousBusinessDevelopmentPartnerId id of the previous business development partner.
	 * @param {Option<string>} currentBusinessDevelopmentPartnerId id of the current business development partner.
	 */
	constructor(readonly leadId: string,
		readonly entity: AuthenticatedEntity,
		readonly previousBusinessDevelopmentPartnerId: Option<string>,
		readonly currentBusinessDevelopmentPartnerId: Option<string>) {}

	static fromJson(json: LeadBDPChangeNotificationDataApiDto): LeadBDPChangeNotificationData {
		const creator = AuthenticatedEntity.fromJson(json.entity);
		return new LeadBDPChangeNotificationData(json.leadId, creator, option(json.previousBusinessDevelopmentPartnerId),
			option(json.currentBusinessDevelopmentPartnerId));
	}

	getLeadReferenceNumber() {
		return getLeadByIdOrRefNo(this.leadId, store.getState()).map(l => l.referenceNumber).getOrElse('');
	}
}